// 存储到 storage 的 key 前缀
export const STORAGE_KEY_START = 'lc_';

/**
 * 解密 Storage 数据
 *
 * 待解密的数据是基于 base64 加密
 *
 * @param {string} encodedData 加密的内容
 * @return {string} 解密的内容
 */
export const decodeStorageData = function (encodedData: string) {
  let res = '';

  try {
    // 对 base64 内容解码
    res = decodeURIComponent(window.atob(`${encodedData}`));
  } catch (err) {
    console.warn('decodeStorageData', err);
  }

  return res;
};

/**
 * 加密 Storage 数据
 *
 * 基于 base64 加密，待加密的数据是明文
 *
 * @param {string} decodedData 待加密的数据是明文
 * @return {string} 解密的内容
 */
export const encodeStorageData = function (decodedData: string) {
  let res = '';

  try {
    // 对 base64 内容解码
    res = window.btoa(encodeURIComponent(decodedData));
  } catch (err) {
    captureException(err);
  }

  return res;
};

/**
 * 获取 localStorage 私人数据
 *
 * @param {*} id 用户标识符
 * @param {*} key 所取的key，可不传，则意味着返回storage对象
 * @return {Object}
 */
export const getLocalStoragePrivate = function ({ id, key }: { id: string; key?: string }) {
  if (!id) {
    return;
  }

  try {
    // 获取加密后的key
    const itemKey = encodeStorageData(`${STORAGE_KEY_START}${id}`);
    // 获取加密后的数据
    const encodeData = window.localStorage.getItem(itemKey);
    // 未找到对应数据
    if (!encodeData) {
      return;
    }
    // 获取解密后数据
    const decodeData = decodeStorageData(encodeData) || '{}';
    const dataObj = JSON.parse(decodeData);
    return key ? dataObj[key] : dataObj;
  } catch (err) {
    captureException(err);
  }
};

/**
 * 设置 localStorage 私人数据
 *
 * @param {*} id 用户标识符
 * @param {*} key 存储的key
 * @param {*} data 存储的值
 * @return {*}
 */
export const setLocalStoragePrivate = function ({
  id,
  key,
  data,
}: {
  id: string;
  key: string;
  data: Record<string, unknown>;
}) {
  if (id && key) {
    try {
      const storageData = getLocalStoragePrivate({ id }) || {};
      // 更新 storage 对象
      storageData[key] = data;
      // 生成加密后数据
      const encodeData = encodeStorageData(JSON.stringify(storageData));
      // 明文 item key 值,
      const storageKey = `${STORAGE_KEY_START}${id}`;
      // 生成加密后的 item key
      const encodeKey = encodeStorageData(storageKey);
      // 存入 localStorage
      window.localStorage.setItem(encodeKey, encodeData);
    } catch (err) {
      captureException(err);
    }
  }
};
